import React, { useState, useEffect } from "react";
import Stars from "components/stars";
import Image from "components/image";
import Slider from "react-slick";
import { Link } from "gatsby";
import TrustedBy from "./trustedby";
import Features from "./features";
import { getSanityMediaUrl } from "@root/helpers/get-sanity-media-url";

const CollectionDetails = ({ data: { author, infoImage, subtitle, title, vehicleImage, sideImage, collaboratorImage, collaboratorName, collaboratorDescription, collaboratorLogo } }) => {
    const [currentSlide, setCurrentSlide] = useState(1);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % 2);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const authorDetails = {
        "- Robert A.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_or7j0aor7j0aor7j.png?v=1764182662",
            address: "Los Angeles, CA"
        },
        "- John K.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_5vi87x5vi87x5vi8.png?v=1764182662",
            address: "Chicago, IL"
        },
        "John K.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_3e4cos3e4cos3e4c.png?v=1764182662",
            address: "Houston, TX"
        },
        "- Lisa N.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_mmd2ecmmd2ecmmd2.png?v=1764182662",
            address: "Philadelphia, PA"
        },
        "- Jim D.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_547ins547ins547i.png?v=1764182662",
            address: "Phoenix, AZ"
        },
        "- Mike N.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_2ng46w2ng46w2ng4.png?v=1764182662",
            address: "San Antonio, TX"
        },
        "- Leonard B.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_ttqwnmttqwnmttqw.png?v=1764182662",
            address: "San Diego, CA"
        },
        "- Brian K.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_4naglb4naglb4nag.png?v=1764182662",
            address: "Dallas, TX"
        },
        "- Neal N.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_l2avkxl2avkxl2av.png?v=1764182662",
            address: "San Jose, CA"
        },
        "- Albert K.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_y7p9jyy7p9jyy7p9.png?v=1764182663",
            address: "Austin, TX"
        },
        "- BRIAN K.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_9prf6w9prf6w9prf.png?v=1764182662",
            address: "Jacksonville, FL"
        },
        "- Leonard B": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_1cf64s1cf64s1cf6.png?v=1764182662",
            address: "Indianapolis, IN"
        },
        "-Robers A.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_elzaw3elzaw3elza.png?v=1764182663",
            address: "Columbus, OH"
        },
        "- ELIRA k.": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_5oycyj5oycyj5oyc.png?v=1764182662",
            address: "Charlotte, NC"
        },
        "- Bryson S": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_idc1dgidc1dgidc1.png?v=1764182662",
            address: "Seattle, WA"
        },
        "Mark Jones": {
            image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Ellipse_1.png?v=1784744756",
            address: "Ohio, OH"
        }
    };

    const getAuthorImage = (author) => {
        return authorDetails[author]?.image || "httpshttps://cdn.shopify.com/s/files/1/0168/9760/5686/files/Gemini_Generated_Image_ttqwnmttqwnmttqw.png?v=1764182662";
    }

    const scrollToFinder = () => {
        const finder = document.getElementsByClassName("product-finder-container")[0];
        if (finder) {
            finder.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 8000,
        speed: 500,
        slidesToShow: 1,
        swipeToSlide: false,
        swipe: false,
        draggable: false,
        touchMove: false,
        slidesToScroll: 1,
    };

    const hasCollaborator = !!collaboratorImage;
    const backgroundImageUrl = hasCollaborator && vehicleImage ? getSanityMediaUrl(vehicleImage) : null;
    const sectionClassName = hasCollaborator ? "promotional-section promotional-section--with-collaborator" : "promotional-section";

    return (
        <div className={`${hasCollaborator ? 'promotional-section--with-collaborator' : ''}`}>
            <div
                className={sectionClassName}
                style={backgroundImageUrl ? { backgroundImage: `url(${backgroundImageUrl})` } : {}}
            >
                <div className="container promotional-section__inner">
                    <div className="promotional-left">
                        {/*  FIT CARD */}
                        <div className="promotional-fit">
                            <p className="promotional-fit-title">
                                {title}
                            </p>
                            <p className="promotional-fit-subtitle">
                                {subtitle}
                            </p>
                        </div>


                        <div className="promotional-image__mobile">
                            <Image image={vehicleImage?.asset} alt={vehicleImage?.alt} />
                        </div>

                        {/* REVIEW CARD */}
                        {!hasCollaborator && (
                            <div className="promotional-review-card">
                                <div className="promotional-review-card__header">
                                    {/* <Stars rating={5} className="" /> */}
                                    <div className="promotional-review-card__stars">
                                        {Array.from({ length: 5 }).map((_, index) => (
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="#FBBC05" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.3514 0.361977C7.59099 -0.120245 8.27889 -0.120244 8.51849 0.361979L10.4752 4.30028C10.5701 4.49124 10.7524 4.62369 10.9634 4.65492L15.3136 5.2989C15.8462 5.37776 16.0588 6.03199 15.6742 6.40887L12.5334 9.48686C12.3811 9.6361 12.3114 9.85042 12.3469 10.0607L13.0787 14.397C13.1683 14.9279 12.6118 15.3323 12.1345 15.083L8.23662 13.047C8.04762 12.9483 7.82227 12.9483 7.63327 13.047L3.73534 15.083C3.25806 15.3323 2.70154 14.9279 2.79115 14.397L3.52297 10.0607C3.55846 9.85042 3.48882 9.6361 3.33653 9.48686L0.195657 6.40887C-0.188926 6.03199 0.0236456 5.37776 0.556305 5.2989L4.90652 4.65492C5.11745 4.62369 5.29976 4.49124 5.39464 4.30028L7.3514 0.361977Z" fill="#FBBC05" />
                                            </svg>
                                        ))}

                                    </div>
                                    <p className="promotional-review-card__date">
                                        Sep 25, 2025
                                    </p>
                                </div>
                                <div className="promotional-review-card__content">
                                    {author?.review}
                                </div>
                                <div className="promotional-review-card__author">
                                    <div className="promotional-review-card__author-image">
                                        <Image image={getAuthorImage(author?.name)} alt={author?.name} />
                                    </div>
                                    <div className="promotional-review-card__author-content">
                                        <div className="promotional-review-card__author-name">
                                            {author?.name}
                                        </div>
                                        <div className="promotional-review-card__author-location">
                                            {authorDetails[author?.name]?.address}
                                        </div>
                                    </div>
                                </div>
                                <div className="promotional__link" onClick={() => scrollToFinder()}>
                                    SHOP NOW
                                </div>
                            </div>
                        )}
                        {hasCollaborator && (
                            <>
                                <div className="promotional-collaborator-card">
                                    <div className="promotional-collaborator-card__image">
                                        {/* <Image image={collaboratorImage?.asset} alt={collaboratorImage?.alt} /> */}
                                        <img src={getSanityMediaUrl(collaboratorImage)} alt={collaboratorImage?.alt} />
                                    </div>

                                    <p className="promotional-collaborator-card__name">{collaboratorName}</p>
                                    <p className="promotional-collaborator-card__description">
                                        {collaboratorDescription && collaboratorDescription.split('|').map((part, index) => (
                                            <span key={index}>{part.trim()}</span>
                                        ))}
                                    </p>
                                    <div className="promotional-collaborator-card__logo">
                                        <Image image={collaboratorLogo?.asset} alt={collaboratorLogo?.alt} />
                                    </div>
                                    <div className="promotional__link" onClick={() => scrollToFinder()}>
                                        SHOP NOW
                                    </div>
                                </div>
                                {/* CALL TO ACTION BUTTON */}

                            </>
                        )}
                    </div>

                    {/* VEHICLE IMAGE */}
                    <div className="promotional-right">
                        <div className="promotional-right__image">
                            <Image image={vehicleImage?.asset} alt={vehicleImage?.alt} />
                        </div>
                    </div>
                </div>

                {/* TRUSTED BY */}
                {!hasCollaborator && (
                    <div className="container promotional__swiper-container">
                        <div className="promotional__swiper ">
                            <div className="promotional__swiper-seal">
                                <img src="https://cdn.shopify.com/s/files/1/0313/1477/2027/files/seal_icon_1.png?v=1764253019" alt="Seal Icon" />
                            </div>
                            <Slider {...sliderSettings}>
                                <Features />
                                <TrustedBy />
                            </Slider>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CollectionDetails;
